import { CurrencyExchange } from "@mui/icons-material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AddIcon from "@mui/icons-material/Add";
import CallIcon from "@mui/icons-material/Call";
import CloseIcon from "@mui/icons-material/Close";
import MailIcon from "@mui/icons-material/Mail";
import RemoveIcon from "@mui/icons-material/Remove";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Card,
  FormHelperText,
  Grid,
  IconButton,
  Pagination,
  Typography,
} from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import {
  addDirectBilling,
  getAllDiscountCodes,
  getClinicStocks,
  getClinicUsers,
  getLocations,
  getRecentTransactionsPayment,
  registerClinicUser,
  updateDirectBilling,
} from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import {
  radioBillTypes,
  radioDiscountTypes,
  radioPaymentTypes,
} from "../../../util/arrayList";
import {
  posAllCategoryList,
  posPetShopCategoryList,
  posPharmacyCategoryList,
} from "../../../util/CommonArrays";
import {
  pointOfSalesAllCategoryList,
  pointOfSalesLocationList,
  pointOfSalesPetShopCategoryList,
  pointOfSalesPharmacyCategoryList,
  UserPaymentTypeList,
} from "../../../util/dropList";
import { getDiscountCodeAvailableToday } from "../../../util/function";
import CommonAdvancePayModalComponent from "../../CommonComponents/CommonAdvancePayModalComponent";

const initValues = {
  billAs: "Pharmacy",
  customerSearch: "",
  userId: null,
  userName: null,
  email: null,
  mobile: null,
  discountType: "percentage",
  discountValue: "",
};

const initialDiscount = { type: "percentage", value: "", discountCode: null };
const addIcon = { width: 15, height: 15, color: AppColors.appPrimary };
const remIcon = { width: 15, height: 15, color: AppColors.gray7 };

const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const initSearch = { name: "", barcodeNo: "", source: "All", category: [] };
const filterByList = [
  "Sub Category",
  "Location",
  "HSN Code",
  "Brand",
  "Nature",
  "Batch Number",
  "Mfg and Expiry Date",
  "Purchase UOM",
  "Sales UOM",
  "Qty Range",
  "Subunit Qty Range",
  "Unit Selling Price Range",
];
const dropFields = ["Location"];

const PointOfSales = ({
  selectedPayment,
  setSelecetdPayment,
  paymentId,
  setPaymentId,
  setActiveTab,
  setPosPayId,
}) => {
  const dispatch = useDispatch();
  const contentToPrint = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState("All");
  const [addedList, setAddedList] = useState([]);
  const [createModVsble, setCreateModVsble] = useState(false);
  const [createValues, setCreateValues] = useState(initValues);
  const [searchEnabled, setSearchEnabled] = useState(false);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [disModVsble, setDisModVsble] = useState(false);
  const [discountValues, setDiscountValues] = useState(initialDiscount);
  const [ttlDisModVsble, setTtlDisModVsble] = useState(false);
  const [prntPrevVsble, setPrntPrevVsble] = useState(false);
  const [errors, setErrors] = useState({});
  const [advancePayVsble, setAdvancePayModVsble] = useState(false);
  const [page, setPage] = useState(1);
  const [usrModVsble, setUsrModVsble] = useState(false);
  const [usrValues, setUsrValues] = useState({});
  const [usrErrs, setUsrErrs] = useState({});
  const [filterValues, setFilterValues] = useState(initFilter);
  const [searchValues, setSearchValues] = useState(initSearch);
  const {
    clinicStocks: stocks,
    users,
    details: clinicDet,
    discountCodes,
    locationList,
  } = useSelector((state) => state?.clinic);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const defaultUrl = "?filter=all&type=resent";
  const itemSize = 15;

  useEffect(() => {
    setFilterValues({
      visible: false,
      added: false,
      selectedList: [],
      values: {},
    });
    setSearchValues({ name: "", barcodeNo: "", source: "All", category: [] });
    dispatch(getClinicStocks());
    getDiscountCodeList();
    dispatch(getLocations());
  }, []);

  useEffect(() => {
    if (paymentId && selectedPayment?.paymentId) {
      const reqList = selectedPayment?.paymentDetails?.map((det) => {
        const reqBatc = getStockDetailsByStockAndBatchId(
          det?.stockId,
          det?.batchId
        );
        const reqObj = {
          administeringCharges: det?.adminChargeAmount?.toString(),
          batchId: det?.batchId,
          batchNo: reqBatc?.batchNo,
          cgst: reqBatc?.cgst,
          quantity: det?.quantity,
          sgst: reqBatc?.sgst,
          stockId: det?.stockId,
          tradeName: reqBatc?.tradeName,
          unitSellingPrice: reqBatc?.unitSellingPrice,
          paymentDetailId: det?.paymentDetailId,
        };
        if (det?.discount > 0) {
          const reqValue =
            det?.discountType === "pr"
              ? det?.discount
              : (Number(det?.discount) / Number(det?.price)) * 100;
          reqObj.type = det?.discountType === "pr" ? "price" : "percentage";
          reqObj.value = reqValue;
        }
        return reqObj;
      });
      setAddedList(reqList);
      setCreateValues({
        billAs: selectedPayment?.type,
        customerSearch: selectedPayment?.userName,
        userId: selectedPayment?.userId,
        userName: selectedPayment?.userName,
        email: selectedPayment?.email,
        mobile: selectedPayment?.mobile,
        discountType: selectedPayment?.discountType ?? "percentage",
        discountValue: selectedPayment?.discountValue ?? "",
      });
      setCreateModVsble(selectedPayment?.paymentId ? true : false);
    }
  }, [paymentId, selectedPayment]);

  const getDiscountCodeList = () => {
    dispatch(getAllDiscountCodes());
  };

  // const getAllStockBatchList = () => {
  //   const list = [];
  //   stocks?.data?.forEach((li) => {
  //     li?.stockBatch?.forEach((btc) => {
  //       list.push({
  //         stockId: li?.stockId,
  //         tradeName: li?.tradeName,
  //         batchId: btc?.batchId,
  //         batchNo: btc?.batchNo,
  //         unitSellingPrice: btc?.unitSellingPrice,
  //         cgst: btc?.cgst,
  //         sgst: btc?.sgst,
  //         administeringCharges: btc?.administeringCharges,
  //       });
  //     });
  //   });
  //   return list;
  // };

  // const getFilteredList = () => {
  //   const reqList = stocks?.data?.filter((dta) => {
  //     return filterType === "All"
  //       ? true
  //       : dta?.category?.toLowerCase() === filterType?.toLowerCase();
  //   });
  //   const list = [];
  //   reqList?.forEach((li) =>
  //     li?.stockBatch?.forEach((btc) => {
  //       list.push({
  //         stockId: li?.stockId,
  //         productName: li?.productName,
  //         tradeName: li?.tradeName,
  //         brand: li?.brand,
  //         batchId: btc?.batchId,
  //         batchNo: btc?.batchNo,
  //         unitSellingPrice: btc?.unitSellingPrice,
  //         cgst: btc?.cgst,
  //         sgst: btc?.sgst,
  //         administeringCharges: btc?.administeringCharges,
  //         expiryDate: btc?.expiryDate,
  //         barcodeNo: btc?.barcodeNo,
  //         subunits: btc?.subunits,
  //         quantity: btc?.quantity,
  //       });
  //     })
  //   );
  //   const reqLists = list?.filter(
  //     (li) =>
  //       li?.subunits > 0 &&
  //       (li?.tradeName
  //         ?.toLocaleLowerCase()
  //         .includes(searchText?.toLowerCase()) ||
  //         li?.productName
  //           ?.toLocaleLowerCase()
  //           .includes(searchText?.toLowerCase()) ||
  //         li?.batchNo
  //           ?.toLocaleLowerCase()
  //           .includes(searchText?.toLowerCase()) ||
  //         li?.barcodeNo
  //           ?.toLocaleLowerCase()
  //           .includes(searchText?.toLowerCase()))
  //   );
  //   return reqLists;
  // };

  const getLocationById = (locId = null) => {
    if (!locId) return null;
    return locationList?.find((li) => li?.id === locId);
  };

  const getLocationsBySource = (source = null) => {
    if (!source) return [];
    return locationList
      ?.filter((li) =>
        source === "All"
          ? li?.category?.toLowerCase() === "pet shop" ||
            li?.category?.toLowerCase() === "pharmacy"
          : li?.category?.toLowerCase() === source?.toLowerCase()
      )
      ?.map((li) => ({
        name: li?.locationName,
        value: li?.locationName,
        id: li?.id,
      }));
  };

  const reqFilteredList = () => {
    const batchFlatList = stocks?.data?.flatMap((li) =>
      li?.stockBatch?.map((batch) => ({
        stockId: li?.stockId,
        productName: li?.productName,
        tradeName: li?.tradeName,
        brand: li?.brand,
        category: li?.category,
        subCategory: li?.subCategory,
        nature: li?.nature,
        hsnSacCode: li?.hsnSacCode,
        ...batch,
      }))
    );
    const reqList = batchFlatList?.filter((li) => {
      const sourceMat = li?.locationId
        ? searchValues?.source?.toLowerCase() === "all"
          ? getLocationById(li?.locationId)?.category?.toLowerCase() ===
              "pharmacy" ||
            getLocationById(li?.locationId)?.category?.toLowerCase() ===
              "pet shop"
          : getLocationById(li?.locationId)?.category?.toLowerCase() ===
            searchValues?.source?.toLowerCase()
        : false;
      const reqCategoryList =
        searchValues?.category?.length > 0
          ? searchValues?.category?.map((cat) => cat?.value?.toLowerCase())
          : searchValues?.source?.toLowerCase() === "all"
          ? posAllCategoryList
          : searchValues?.source?.toLowerCase() === "pharmacy"
          ? posPharmacyCategoryList
          : posPetShopCategoryList;

      const nameMat =
        searchValues?.name?.length > 0
          ? li?.productName
              ?.toLowerCase()
              ?.includes(searchValues?.name?.toLowerCase()) ||
            li?.tradeName
              ?.toLowerCase()
              ?.includes(searchValues?.name?.toLowerCase())
          : true;
      const barCodMat =
        searchValues?.barcodeNo?.length > 0
          ? li?.barcodeNo
              ?.toLowerCase()
              ?.includes(searchValues?.barcodeNo?.toLowerCase())
          : true;
      const categoryMat = reqCategoryList?.includes(
        li?.category?.toLowerCase()
      );

      const subCategoryMat =
        filterValues?.selectedList?.includes("Sub Category") &&
        filterValues?.values?.["Sub Category"]?.length > 0
          ? li?.subCategory
              ?.toLowerCase()
              ?.includes(filterValues?.values?.["Sub Category"]?.toLowerCase())
          : true;
      const locationMatch = li?.locationId
        ? filterValues?.selectedList?.includes("Location") &&
          filterValues?.values?.["Location"]?.length > 0
          ? filterValues?.values?.["Location"]
              ?.map((loc) => loc?.id)
              ?.includes(li?.locationId)
          : true
        : false;
      const hsnCodeMat =
        filterValues?.selectedList?.includes("HSN Code") &&
        filterValues?.values?.["HSN Code"]?.length > 0
          ? li?.hsnSacCode
              ?.toLowerCase()
              ?.includes(filterValues?.values?.["HSN Code"]?.toLowerCase())
          : true;
      const brandMat =
        filterValues?.selectedList?.includes("Brand") &&
        filterValues?.values?.["Brand"]?.length > 0
          ? li?.brand
              ?.toLowerCase()
              ?.includes(filterValues?.values?.["Brand"]?.toLowerCase())
          : true;
      const natureMat =
        filterValues?.selectedList?.includes("Nature") &&
        filterValues?.values?.["Nature"]?.length > 0
          ? li?.nature
              ?.toLowerCase()
              ?.includes(filterValues?.values?.["Nature"]?.toLowerCase())
          : true;
      const batchNumberMat =
        filterValues?.selectedList?.includes("Batch Number") &&
        filterValues?.values?.["Batch Number"]?.length > 0
          ? li?.batchNo
              ?.toLowerCase()
              ?.includes(filterValues?.values?.["Batch Number"]?.toLowerCase())
          : true;
      const purchaseUomMat =
        filterValues?.selectedList?.includes("Purchase UOM") &&
        filterValues?.values?.["Purchase UOM"]?.length > 0
          ? li?.purchaseUom
              ?.toLowerCase()
              ?.includes(filterValues?.values?.["Purchase UOM"]?.toLowerCase())
          : true;
      const salesUomMat =
        filterValues?.selectedList?.includes("Sales UOM") &&
        filterValues?.values?.["Sales UOM"]?.length > 0
          ? li?.salesUom
              ?.toLowerCase()
              ?.includes(filterValues?.values?.["Sales UOM"]?.toLowerCase())
          : true;
      const qtyRangeMat =
        filterValues?.selectedList?.includes("Qty Range") &&
        (filterValues?.values?.["Min Qty"]?.length > 0 ||
          filterValues?.values?.["Max Qty"]?.length > 0)
          ? li?.quantity >= Number(filterValues?.values?.["Min Qty"] ?? 0) &&
            li?.quantity <= Number(filterValues?.values?.["Max Qty"] ?? 0)
          : true;
      const subunitQtyRangeMat =
        filterValues?.selectedList?.includes("Subunit Qty Range") &&
        (filterValues?.values?.["Min Subunit Qty"]?.length > 0 ||
          filterValues?.values?.["Max Subunit Qty"]?.length > 0)
          ? li?.subunits >=
              Number(filterValues?.values?.["Min Subunit Qty"] ?? 0) &&
            li?.subunits <=
              Number(filterValues?.values?.["Max Subunit Qty"] ?? 0)
          : true;
      const unitSellingPriceRangeMat =
        filterValues?.selectedList?.includes("Unit Selling Price Range") &&
        (filterValues?.values?.["Min Unit Selling Price"]?.length > 0 ||
          filterValues?.values?.["Max Unit Selling Price"]?.length > 0)
          ? li?.unitSellingPrice >=
              Number(filterValues?.values?.["Min Unit Selling Price"] ?? 0) &&
            li?.unitSellingPrice <=
              Number(filterValues?.values?.["Max Unit Selling Price"] ?? 0)
          : true;
      const dateRangeMat =
        filterValues?.selectedList?.includes("Mfg and Expiry Date") &&
        filterValues?.values?.["Mfg Date"] &&
        filterValues?.values?.["Expiry Date"]
          ? !li?.mfgDate || !li?.expiryDate
            ? false
            : new Date(li?.mfgDate) >=
                new Date(filterValues?.values?.["Mfg Date"]) &&
              new Date(li?.expiryDate) <=
                new Date(filterValues?.values?.["Expiry Date"])
          : true;

      return (
        sourceMat &&
        nameMat &&
        barCodMat &&
        categoryMat &&
        subCategoryMat &&
        locationMatch &&
        hsnCodeMat &&
        brandMat &&
        natureMat &&
        batchNumberMat &&
        purchaseUomMat &&
        salesUomMat &&
        qtyRangeMat &&
        subunitQtyRangeMat &&
        unitSellingPriceRangeMat &&
        dateRangeMat
      );
    });
    return reqList;
  };

  const totalPage = Math.ceil(reqFilteredList()?.length / itemSize);

  const getCurrentPageRecord = (list) => {
    return list?.slice((page - 1) * itemSize, page * itemSize);
  };

  const getStockDetailsByStockAndBatchId = (stckId, batcId) => {
    const stckData = stocks?.data?.find((stc) => stc?.stockId === stckId);
    const batchDet = stckData?.stockBatch?.find(
      (bat) => bat?.batchId === batcId
    );
    return {
      stockId: stckData?.stockId,
      tradeName: stckData?.tradeName,
      batchId: batchDet?.batchId,
      batchNo: batchDet?.batchNo,
      unitSellingPrice: batchDet?.unitSellingPrice,
      cgst: batchDet?.cgst,
      sgst: batchDet?.sgst,
      administeringCharges: batchDet?.administeringCharges,
    };
  };

  const handleUpdateQuantity = (itm, quantity) => {
    const prevItm = addedList?.find((li) => li?.batchId === itm?.batchId);
    const reqObj = { ...itm, quantity: Number(quantity ?? 0) };
    if (prevItm) {
      reqObj.quantity = Number(quantity ?? 0);
      const reqList = addedList?.map((li) => {
        if (li?.batchId === itm?.batchId) return reqObj;
        return li;
      });
      setAddedList(reqList);
    } else {
      setAddedList((prev) => [...prev, reqObj]);
    }
  };

  const handleAddItem = (itm) => {
    const prevItm = addedList?.find((li) => li?.batchId === itm?.batchId);
    const reqObj = { ...itm, quantity: 1 };
    if (prevItm) {
      reqObj.quantity = Number(prevItm?.quantity ?? 0) + 1;
      const reqList = addedList?.map((li) => {
        if (li?.batchId === itm?.batchId) return reqObj;
        return li;
      });
      setAddedList(reqList);
    } else {
      setAddedList((prev) => [...prev, reqObj]);
    }
  };

  const removeItem = (itm) => {
    const prevItm = addedList?.find((li) => li?.batchId === itm?.batchId);
    let reqObj = { ...itm, quantity: Number(prevItm?.quantity ?? 0) - 1 };

    // if (reqObj?.quantity > 0) {
    const reqList = addedList?.map((li) => {
      if (li?.batchId === itm?.batchId) return reqObj;
      return li;
    });
    setAddedList(reqList);
    // } else {
    //   const reqList = addedList?.filter((li) => li?.batchId !== itm?.batchId);
    //   setAddedList(reqList);
    // }
  };

  const handleCreate = () => {
    setCreateModVsble(true);
    setPaymentId(null);
  };

  const handleChange = (name, value) => {
    setCreateValues({ ...createValues, [name]: value });
    if (name === "customerSearch") {
      if (value?.length > 2) {
        dispatch(getClinicUsers(`?search=${value}&itemSize=30&page=1`));
      }
      setSearchEnabled(true);
    }
  };

  const userListByFilter = () => {
    if (createValues?.customerSearch === "") return [];
    const search = createValues?.customerSearch?.toLocaleLowerCase();
    const reqList = users?.filter(
      (usr) =>
        usr?.name?.toLowerCase().includes(search) ||
        usr?.email?.toLowerCase().includes(search) ||
        usr?.mobile?.toLowerCase().includes(search)
    );
    return reqList;
  };

  const handleSelectedUser = (usr) => {
    setCreateValues({
      ...createValues,
      customerSearch: usr?.name,
      userName: usr?.name,
      userId: usr?.id,
      email: usr?.email,
      mobile: usr?.mobile,
      advanceAmount: usr?.advanceAmount,
    });
    setErrors({ ...errors, userId: false });
    setSearchEnabled(false);
  };

  const handleSuccess = (status = "", payId) => {
    dispatch(getRecentTransactionsPayment(defaultUrl));
    setCreateModVsble(false);
    setCreateValues(initValues);
    setPaymentId(null);
    setAddedList([]);
    setErrors({});
    if (status === "finalize") {
      setPosPayId(payId ?? null);
      setActiveTab("Payments");
    }
  };

  const handleSubmit = (status = "") => {
    if (!createValues?.userId || addedList?.length === 0) {
      return setErrors({
        userId: !createValues?.userId,
        addedList: addedList?.length === 0,
      });
    }
    const reqList = addedList?.map((li) => {
      const reqObj = {
        billType: "prescribed",
        adminCharge: "N",
        adminChargeAmount: 0,
        name: li?.tradeName,
        quantity: Number(li?.quantity ?? 1),
        type: "product",
        discount: 0,
        percentage: li?.type === "percentage",
        subUnit: "Unit",
        batchId: li?.batchId,
        stockId: li?.stockId,
        tax: 0,
      };
      if (li?.batchId) {
        const btchDet = getBatchDetailsByStockAndBatchId(
          li?.stockId,
          li?.batchId
        );
        let tax = 0,
          discount = 0,
          total = 0;
        const taxPercent =
          (createValues?.billAs === "Pharmacy"
            ? clinicDet?.pharmacyTaxId
            : clinicDet?.petShopTaxId
          )?.length > 0
            ? Number(btchDet?.cgst ?? 0) + Number(btchDet?.sgst ?? 0)
            : 0;
        const reqPercent = 100 + Number(taxPercent);
        const unitPrice =
          Number(btchDet?.unitSellingPrice) / (reqPercent / 100);
        const taxValue = Number(btchDet?.unitSellingPrice) - Number(unitPrice);
        reqObj.price = unitPrice;
        reqObj.mrpPrice = Number(btchDet?.unitSellingPrice ?? 0);
        reqObj.mrpDiscount = Number(li?.value ?? 0);
        if (li?.type === "price" && li?.value) {
          const taxableValue = Number(unitPrice) - Number(li?.value ?? 0);
          reqObj.price = unitPrice;
          reqObj.mrpPrice = Number(btchDet?.unitSellingPrice);
          reqObj.mrpDiscount = Number(li?.value) ?? 0;
          const prdTaxValue =
            Number(li?.quantity) * ((taxPercent / 100) * Number(taxableValue));
          tax = Number(prdTaxValue);
          discount = Number(li?.value ?? 0);
          total =
            Number(li?.quantity) * Number(taxableValue) + Number(prdTaxValue);
        }
        if (li?.type === "percentage" && li?.value) {
          const perPrice =
            Number(Number(Number(unitPrice) / 100) * Number(li?.value ?? 0)) ??
            0;
          const taxableValue = Number(unitPrice) - Number(perPrice ?? 0);
          reqObj.price = unitPrice;
          reqObj.mrpPrice = Number(btchDet?.unitSellingPrice);
          reqObj.mrpDiscount =
            Number(
              Number(Number(btchDet?.unitSellingPrice) / 100) *
                Number(li?.value ?? 0)
            ) ?? 0;
          const prdTaxValue =
            Number(li?.quantity) * ((taxPercent / 100) * Number(taxableValue));
          tax = Number(prdTaxValue);
          discount = Number(perPrice);
          total =
            Number(li?.quantity) * Number(taxableValue) + Number(prdTaxValue);
        }
        if (!li?.type && !li?.value) {
          total = Number(
            Number(btchDet?.unitSellingPrice) * Number(li?.quantity)
          );
          tax = Number(li?.quantity) * Number(taxValue);
        }
        reqObj.tax = tax;
        reqObj.discount = discount;
        reqObj.total = total;
      }
      if (li?.paymentDetailId) reqObj.paymentDetaisId = li?.paymentDetailId;
      return reqObj;
    });
    const data = {
      userId: createValues?.userId,
      type: createValues?.billAs,
      paymentOption: status,
      direct: reqList,
      discountValue: createValues?.discountValue ?? 0,
      discountType: createValues?.discountType ?? "percentage",
    };
    if (createValues?.billingId) {
      data.usedDiscountIds = uniq([
        ...(selectedPayment?.usedDiscountIds ?? []),
        createValues?.billingId?.toString(),
      ]);
    }
    if (paymentId) {
      dispatch(updateDirectBilling({ paymentId, data })).then((res) => {
        if (res?.payload) {
          handleSuccess(status, paymentId ?? res?.payload?.data ?? null);
        }
      });
    } else {
      dispatch(addDirectBilling(data)).then((res) => {
        if (res?.payload) {
          handleSuccess(status, res?.payload?.data ?? null);
        }
      });
    }
  };

  const getPriceByStockAndBatchId = (stockId, batchId) => {
    return (
      stocks?.data
        ?.find((stc) => stc?.stockId === stockId)
        ?.stockBatch?.find((li) => li?.batchId === batchId)?.unitSellingPrice ??
      0
    );
  };

  const getBatchDetailsByStockAndBatchId = (stockId, batchId) => {
    return stocks?.data
      ?.find((stc) => stc?.stockId === stockId)
      ?.stockBatch?.find((li) => li?.batchId === batchId);
  };

  const handleDiscount = (dta) => {
    setDiscountValues({
      ...discountValues,
      type: dta?.type ?? "percentage",
      value: dta?.value ?? "",
    });
    setSelectedBatchId(dta?.batchId);
    setDisModVsble(true);
  };

  const onCloseDisMod = () => {
    setDisModVsble(false);
    setDiscountValues(initialDiscount);
    setSelectedBatchId(null);
  };

  const onChangeDiscount = (name, value) => {
    const errs = { ...errors };
    if (name === "value") {
      errs.value = Number(value) > 0 ? false : true;
    }
    if (name === "discountCode") {
      errs.discountCode = value?.value ? false : true;
    }
    setErrors(errs);
    setDiscountValues({ ...discountValues, [name]: value });
  };

  const handleAddDiscount = () => {
    const reqList = addedList?.map((li) => {
      if (li?.batchId === selectedBatchId) {
        return {
          ...li,
          type: discountValues?.type,
          value: discountValues?.value,
        };
      }
      return li;
    });
    setAddedList(reqList);
    onCloseDisMod();
  };

  const getDiscountAndTotal = () => {
    let discount = 0,
      total = 0,
      tax = 0;
    addedList?.forEach((li) => {
      const btchDet = getBatchDetailsByStockAndBatchId(
        li?.stockId,
        li?.batchId
      );

      const taxPercent =
        (createValues?.billAs === "Pharmacy"
          ? clinicDet?.pharmacyTaxId
          : clinicDet?.petShopTaxId
        )?.length > 0
          ? Number(btchDet?.cgst ?? 0) + Number(btchDet?.sgst ?? 0)
          : 0;
      const reqPercent = 100 + Number(taxPercent);
      const unitPrice = Number(btchDet?.unitSellingPrice) / (reqPercent / 100);
      const taxValue = Number(btchDet?.unitSellingPrice) - Number(unitPrice);

      if (li?.type === "price" && li?.value) {
        const taxableValue = Number(unitPrice) - Number(li?.value ?? 0);
        const prdTaxValue =
          Number(li?.quantity) * ((taxPercent / 100) * Number(taxableValue));
        tax = Number(tax) + Number(prdTaxValue);
        discount =
          Number(discount) + Number(li?.value ?? 0) * Number(li?.quantity);
        total =
          Number(total) +
          (Number(li?.quantity) * Number(taxableValue) + Number(prdTaxValue));
      }
      if (li?.type === "percentage" && li?.value) {
        const perPrice =
          Number(Number(Number(unitPrice) / 100) * Number(li?.value ?? 0)) ?? 0;
        const taxableValue = Number(unitPrice) - Number(perPrice ?? 0);
        const prdTaxValue =
          Number(li?.quantity) * ((taxPercent / 100) * Number(taxableValue));
        tax = Number(tax) + Number(prdTaxValue);
        discount = Number(discount) + Number(perPrice) * Number(li?.quantity);
        total =
          Number(total) +
          (Number(li?.quantity) * Number(taxableValue) + Number(prdTaxValue));
      }
      if (!li?.type && !li?.value) {
        total =
          Number(total) +
          Number(Number(btchDet?.unitSellingPrice) * Number(li?.quantity));
        tax = Number(tax) + Number(li?.quantity) * Number(taxValue);
      }
    });
    return { discount, total, tax };
  };

  const handleClosePrintModal = () => {
    setPrntPrevVsble(false);
  };

  const handlePrint = useReactToPrint({
    documentTitle: `${clinicDet?.name ?? ""}-${"1234"}`,
    removeAfterPrint: true,
  });

  const getListWithQuantity = () => {
    return addedList?.filter((li) => li?.quantity > 0);
  };

  const handleCloseCreateMod = () => {
    setSelecetdPayment(null);
    setPaymentId(null);
    setCreateModVsble(false);
    setCreateValues(initValues);
    setAddedList([]);
  };

  const handleChangePage = (e, selectedPage) => {
    setPage(selectedPage);
  };

  const handleAddUser = () => {
    setUsrModVsble(true);
  };

  const usrModClose = () => {
    setUsrModVsble(false);
    setUsrValues({});
    setUsrErrs({});
  };

  const handleValueChange = (e, name) => {
    const value = e?.target?.value;
    setUsrValues({ ...usrValues, [name]: value });
    setUsrErrs({
      ...usrErrs,
      [name]:
        value?.length > 0
          ? ""
          : name === "email"
          ? ""
          : "This field is required",
    });
  };

  const createUser = () => {
    if (
      usrValues?.userName?.length === 0 ||
      !usrValues?.userName ||
      usrValues?.userMobile?.length === 0 ||
      !usrValues?.userMobile
    ) {
      let errs = { ...usrErrs };
      if (usrValues?.userName?.length === 0 || !usrValues?.userName) {
        errs = { ...errs, userName: "This field is required" };
      }
      if (usrValues?.userMobile?.length === 0 || !usrValues?.userMobile) {
        errs = { ...errs, userMobile: "This field is required" };
      }
      setUsrErrs(errs);
      return;
    }
    const form = new FormData();
    form.append("userName", usrValues?.userName);
    form.append("userMobile", usrValues?.userMobile);
    if (usrValues?.email?.length > 0) form.append("email", usrValues?.email);
    dispatch(registerClinicUser(form)).then((res) => {
      if (res?.payload?.status === 201) usrModClose();
    });
  };

  const handleClosePayMod = (from = null) => {
    setAdvancePayModVsble(false);
    setUsrErrs({});
    if (from === null) {
      setUsrValues({});
    }
  };

  const handleCollectAdvance = () => {
    setUsrValues({
      paymentType: radioPaymentTypes?.[0]?.value,
      userId: createValues?.userId,
      userName: createValues?.userName,
      mobile: createValues?.mobile,
      email: createValues?.email,
      paymentMode: UserPaymentTypeList?.[0],
      advanceAmount: createValues?.advanceAmount,
    });
    setAdvancePayModVsble(true);
  };

  const handleApplyDiscount = () => {
    setDiscountValues({
      ...discountValues,
      type: createValues?.discountType,
      value: createValues?.discountValue,
    });
    setTtlDisModVsble(true);
  };

  const onCloseTtlDisMod = () => {
    setTtlDisModVsble(false);
    setDiscountValues(initialDiscount);
    setErrors({ ...errors, value: false });
  };

  const handleAddTtlDiscount = () => {
    const errs = {};
    if (discountValues?.type === "code") {
      errs.discountCode = discountValues?.discountCode?.value ? false : true;
    }
    if (discountValues?.type !== "code") {
      errs.value =
        discountValues?.value?.length > 0
          ? Number(discountValues?.value) > 0
            ? false
            : true
          : true;
    }
    // errs.amt =
    //   discountValues?.value?.length > 0
    //     ? Number(discountValues?.value) > 0
    //       ? ""
    //       : "Value must be positive"
    //     : "This field is required";
    if (
      (discountValues?.type === "code" && errs?.discountCode) ||
      (discountValues?.type !== "code" && errs?.value)
    ) {
      return setErrors(errs);
    }
    // if (errs?.amt?.length > 0) return setErrors({ value: true });
    const reqDiscountType =
      discountValues?.type === "code"
        ? discountValues?.discountCode?.discountType?.toLowerCase()
        : discountValues?.type?.toLowerCase();
    const reqDiscountValue =
      discountValues?.type === "code"
        ? discountValues?.discountCode?.discountValue
        : discountValues?.value;
    const reqList = addedList?.map((li) => {
      const reqObj = { ...li };
      if (reqDiscountType === "percentage") {
        reqObj.type = reqDiscountType;
        reqObj.value = reqDiscountValue;
      }
      if (reqDiscountType !== "percentage") {
        reqObj.type = reqDiscountType;
        const taxPerent =
          (createValues?.billAs === "Pharmacy"
            ? clinicDet?.pharmacyTaxId
            : clinicDet?.petShopTaxId
          )?.length > 0
            ? Number(li?.cgst ?? 0) + Number(li?.sgst ?? 0)
            : 0;
        const reqPercent = 100 + Number(taxPerent);
        const unitPrice = Number(li?.unitSellingPrice) / (reqPercent / 100);
        reqObj.value = Number(
          Number(
            Number(
              Number(unitPrice) /
                Number(
                  getDiscountAndTotal()?.total + getDiscountAndTotal()?.discount
                )
            ) * Number(reqDiscountValue)
          )
        );
      }
      return reqObj;
    });
    setAddedList(reqList);
    const reqObj = { ...createValues };
    reqObj.discountType = reqDiscountType;
    reqObj.discountValue = reqDiscountValue;
    reqObj.billingId =
      discountValues?.type === "code"
        ? discountValues?.discountCode?.billingId ?? null
        : null;
    setCreateValues(reqObj);
    setTtlDisModVsble(false);
  };

  const onRemoveTtlDiscount = () => {
    const reqList = addedList?.map((li) => {
      const reqObj = { ...li };
      if (li?.type) delete reqObj.type;
      if (li?.value) delete reqObj.value;
      return reqObj;
    });
    setAddedList(reqList);
    const reqObj = {
      ...createValues,
      discountType: "percentage",
      discountValue: "",
    };
    setCreateValues(reqObj);
    setTtlDisModVsble(false);
  };

  const getBillQty = () => {
    return addedList?.length > 0
      ? addedList?.reduce((acc, curr) => acc + curr?.quantity, 0) ?? 0
      : 0;
  };

  const getTotal = () => {
    return addedList?.length > 0
      ? addedList?.reduce(
          (acc, curr) =>
            acc +
            Number(
              Number(curr?.unitSellingPrice ?? 0) * Number(curr?.quantity ?? 0)
            )
        ) ?? 0
      : 0;
  };

  const getDiscountCodes = () => {
    const todayDiscounts = getDiscountCodeAvailableToday(
      discountCodes ?? [],
      createValues?.userId ?? null,
      getTotal() ?? 0,
      getBillQty() ?? 0,
      false,
      addedList?.some((li) => Number(li?.value ?? 0) > 0) ?? false,
      null
    );
    return todayDiscounts?.map((dc) => ({
      name: dc?.discountCode,
      value: dc?.discountCode,
      discountType: dc?.discountType,
      discountValue: dc?.discountValue,
      purchaseType: dc?.purchaseType,
      billingId: dc?.billId,
      limitUsagePerCustomer: dc?.limitUsagePerCustomer,
      limitUsageTotal: dc?.limitUsageTotal,
    }));
  };

  const onSearchChange = (name, value) => {
    const reqObj = {
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    };
    if (name === "source") {
      reqObj.category = [];
    }
    setSearchValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({
        ...initFilter,
        selectedList: [],
        values: { type: "all" },
      });
    });
    // onPetsApiCall(1, true);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: {},
    };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    // onPetsApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const getMinLable = (name) => {
    if (name === "Qty Range") return "Min Qty";
    if (name === "Subunit Qty Range") return "Min Subunit Qty";
    if (name === "Unit Selling Price Range") return "Min Unit Selling Price";
    return "";
  };

  const getMaxLable = (name) => {
    if (name === "Qty Range") return "Max Qty";
    if (name === "Subunit Qty Range") return "Max Subunit Qty";
    if (name === "Unit Selling Price Range") return "Max Unit Selling Price";
    return "";
  };

  return (
    <>
      <Grid container className="ph2">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="back-white"
        >
          <TopBar>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <div className="top-row-cen-con w100Per">
                  <div className="w15Per">
                    <CustomTextField
                      placeholder="Product/Trade Name"
                      fullWidth
                      name="name"
                      handleChange={(e) =>
                        onSearchChange("name", e?.target?.value)
                      }
                      value={searchValues?.name}
                      backgroundColor={AppColors.lightBlue2}
                      label="Product/Trade Name"
                    />
                  </div>
                  <div className="w15Per ml20">
                    <CustomTextField
                      placeholder="Barcode Number"
                      fullWidth
                      name="barcodeNo"
                      handleChange={(e) =>
                        onSearchChange("barcodeNo", e?.target?.value)
                      }
                      value={searchValues?.barcodeNo}
                      backgroundColor={AppColors.lightBlue2}
                      label="Barcode Number"
                    />
                  </div>
                  <div className="w15Per ml20">
                    <CustomSelect
                      list={pointOfSalesLocationList}
                      value={searchValues?.source}
                      name="source"
                      handleChange={(e) =>
                        onSearchChange("source", e?.target?.value)
                      }
                      label="Source"
                      select
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>
                  <div className="w15Per ml20">
                    <CustomSelect
                      list={
                        searchValues?.source?.toLowerCase() === "all"
                          ? pointOfSalesAllCategoryList
                          : searchValues?.source?.toLowerCase() === "pharmacy"
                          ? pointOfSalesPharmacyCategoryList
                          : pointOfSalesPetShopCategoryList
                      }
                      value={searchValues?.category ?? []}
                      name="category"
                      handleChange={(e) =>
                        onSearchChange("category", e?.target?.value)
                      }
                      label="Category"
                      multiSelectSearchCheck
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>
                  <div
                    className="flex-row-ali-cen ml20 filter cursor"
                    onClick={() => onFilterChange("visible", true)}
                  >
                    <TuneIcon sx={{ color: AppColors.appPrimary }} />
                    <Typography className="font-medium fs12 blue-color ml10">
                      {filterValues?.selectedList?.length > 0
                        ? `${filterValues?.selectedList?.length} `
                        : ""}
                      Filter
                    </Typography>
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Reset"
                      onClick={onReset}
                      smallBtn
                      redBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Create"
                      onClick={handleCreate}
                      smallBtn
                    />
                  </div>
                </div>
              </div>
              {/* <div className="flex-row">
                <div className="top-row-cen-con w100Per textfield">
                  <div className="w40Per">
                    <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearchText(e.target.value)}
                      value={searchText}
                      searchBill
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>
                  {!createModVsble ? (
                    <div className="ml30">
                      <div className="ml20">
                        <CustomButton
                          text="Create"
                          onClick={handleCreate}
                          smallBtn
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div> */}
              {/* <div className="flex-row-ali-cen mv10">
                <Typography
                  className={`txt-semi-bold fs12 gray-back2 cursor ${
                    filterType === "All" ? "tab-green-back" : "tab-gray-back"
                  }`}
                  onClick={() => setFilterType("All")}
                >
                  All
                </Typography>
                <Typography
                  className={`txt-semi-bold fs12 gray-back2 cursor ml15 ${
                    filterType === "Medication"
                      ? "tab-green-back"
                      : "tab-gray-back"
                  }`}
                  onClick={() => setFilterType("Medication")}
                >
                  Medication
                </Typography>
                <div
                  className={`txt-semi-bold fs12 gray-back2 cursor ml15 ${
                    filterType === "Vaccines"
                      ? "tab-green-back"
                      : "tab-gray-back"
                  }`}
                  onClick={() => setFilterType("Vaccines")}
                >
                  Vaccines
                </div>
              </div> */}
            </Grid>
            <Typography className="font-medium fs12 gray28 mv10">
              Number of Records: {reqFilteredList()?.length ?? 0}
            </Typography>
          </TopBar>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="mv3 back-white"
        >
          {getCurrentPageRecord(reqFilteredList())?.length > 0 ? (
            <div className="flex-row-wrap1">
              {getCurrentPageRecord(reqFilteredList())?.map((li) => {
                const qty =
                  addedList?.find((adLi) => adLi?.batchId === li?.batchId)
                    ?.quantity ?? 0;
                return (
                  <Card
                    sx={{
                      borderRadius: 1,
                      padding: 2,
                      borderTopColor: AppColors.appPrimary,
                      width: 180,
                    }}
                    className="mh10 mv10"
                    key={li?.batchId}
                  >
                    <Typography className="black13 fs12 font-medium">
                      {li?.productName}
                    </Typography>
                    {/* <Custom3dotString
                      str={li?.tradeName}
                      className="black13 fs12 font-medium"
                      length={18}
                    /> */}
                    <Typography className="gray16 fs10 font-medium">
                      Brand: {li?.brand}
                    </Typography>
                    <Typography className="gray16 fs10 font-medium">
                      Batch No: {li?.batchNo}
                    </Typography>
                    <Typography className="gray16 fs10 font-medium">
                      Expiry Date:{" "}
                      {moment(li?.expiryDate).format("DD MMM YYYY")}
                    </Typography>
                    <div className="mt10 flex-row-ali-cen h30">
                      <div>
                        <Typography className="blue-color fs14 txt-regular">
                          Rs. {Number(li?.unitSellingPrice)?.toFixed(2)}
                        </Typography>
                        <Typography className="gray16 fs10 font-medium">
                          {`(incl. Taxes)`}
                        </Typography>
                      </div>
                    </div>
                    {createModVsble ? (
                      <div className="flex-row-ali-cen mt10 h40">
                        <div className="flex-row-ali-cen">
                          {qty > 0 ? (
                            <div
                              className="flex-center cursor minus-icon"
                              onClick={() => removeItem(li)}
                            >
                              <RemoveIcon sx={remIcon} />
                            </div>
                          ) : null}
                        </div>
                        {qty > 0 ? (
                          <div className="ph10">
                            <CustomTextField
                              label=""
                              name="quantity"
                              fullWidth
                              handleChange={(e) =>
                                handleUpdateQuantity(li, e?.target?.value)
                              }
                              value={qty ?? 0}
                              type="number"
                            />
                          </div>
                        ) : // <Typography
                        //   className="black14 fs14 txt-semi-bold flex-center"
                        //   style={{ width: 25 }}
                        // >
                        //   {qty}
                        // </Typography>
                        null}
                        <div className="flex-end">
                          <div
                            className="flex-center cursor plus-icon"
                            onClick={() => handleAddItem(li)}
                          >
                            <AddIcon sx={addIcon} />
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </Card>
                );
              })}
            </div>
          ) : (
            <div className="flex-center mt20">
              <Typography className="txt-regular">
                No records available
              </Typography>
            </div>
          )}

          {Math.ceil(reqFilteredList()?.length / itemSize) > 1 ? (
            <div className="flex-end mr20">
              <Pagination
                count={totalPage}
                variant="outlined"
                color="primary"
                page={page}
                onChange={handleChangePage}
              />
            </div>
          ) : null}
        </Grid>
      </Grid>
      {/* Right side static container */}
      {createModVsble ? (
        <div className="payment-rht">
          <div className="flex-row-ali-cen">
            <div className="flex-start">
              <Typography className="blue-color txt-semi-bold fs16 mv10 ml10">
                {paymentId ? "Update Bill" : "Create Bill"}
              </Typography>
            </div>
            {createModVsble ? (
              <div className="flex1-end">
                <IconButton
                  onClick={handleCloseCreateMod}
                  sx={{ color: (theme) => theme.palette.grey[500] }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            ) : null}
          </div>
          <div className="scroll-85vh">
            {createModVsble ? (
              <Grid container spacing={2} className="ph10">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="txt-semi-bold fs14 mark-balck">Bill as</div>
                  <CustomCheckbox
                    radio
                    onChange={(e) => handleChange("billAs", e?.target?.value)}
                    radios={radioBillTypes}
                    defaultValue={createValues?.billAs ?? "Pharmacy"}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-end mb5 mtMin25">
                    <Typography
                      className="blue-color cursor txt-semi-bold fs14 underline"
                      onClick={handleAddUser}
                    >
                      Add new customer
                    </Typography>
                  </div>
                  <CustomTextField
                    name="customerSearch"
                    fullWidth
                    handleChange={(e) =>
                      handleChange("customerSearch", e?.target?.value)
                    }
                    value={createValues?.customerSearch}
                    placeholder="Search Customer here..."
                    error={errors?.userId}
                    helperText={errors?.userId ? "Please Select Customer" : ""}
                  />
                </Grid>
                {createValues?.customerSearch?.length > 0 && searchEnabled && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {userListByFilter()?.length > 0 &&
                      userListByFilter()?.map((usr) => {
                        return (
                          <div
                            className="flex-row-ali-cen cursor mv10 cus-box"
                            key={usr?.id}
                            onClick={() => handleSelectedUser(usr)}
                          >
                            <div className="w15Per">
                              <div className="flex-center">
                                <img
                                  src={require("../../../assets/images/png/contact.png")}
                                  className="imghw40"
                                />
                              </div>
                            </div>
                            <div className="w75Per">
                              <div className="flex-coloum ml10">
                                <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                                  Parent Name:
                                  <Typography className="txt-regular fs12 black15 ml5">
                                    {usr?.name}
                                  </Typography>
                                </Typography>
                                <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                                  Phone:
                                  <Typography className="txt-regular fs12 black15 ml5">
                                    {usr?.mobile}
                                  </Typography>
                                </Typography>
                                <Typography className="blue-color txt-semi-bold fs12 flex-row-ali-cen">
                                  Email:
                                  <Typography className="txt-regular fs12 black15 ml5">
                                    {usr?.email}
                                  </Typography>
                                </Typography>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </Grid>
                )}
                {!searchEnabled &&
                (createValues?.email ||
                  createValues?.mobile ||
                  createValues?.userName) ? (
                  <div className="ml20 w100Per">
                    <div className="dashed-card mv20 p20">
                      <div className="flex-row">
                        <AccountCircleOutlinedIcon
                          sx={{ width: 25, height: 25 }}
                        />

                        <Custom3dotString
                          str={createValues?.userName}
                          className="font-bold black fs12 ml10 flex-center"
                          length={15}
                        />
                      </div>
                      <div className="flex-row mt10">
                        <MailIcon
                          sx={{
                            color: AppColors.appPrimary,
                            width: 20,
                            height: 20,
                          }}
                        />
                        <div className="flex-center">
                          <Typography className="txt-regular card-gray-color fs12 ml10 ovrflw-wrp-anywre">
                            {createValues?.email}
                          </Typography>
                        </div>
                      </div>
                      <div className="flex-row mt10">
                        <CallIcon
                          sx={{
                            color: AppColors.appPrimary,
                            width: 20,
                            height: 20,
                          }}
                        />
                        <div className="flex-center">
                          <Typography className="txt-regular card-gray-color fs12 ml10">
                            {createValues?.mobile}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div
                  className={`box-hor-split ml20  ${
                    !createValues?.userId ? "mt10" : ""
                  }`}
                />
                <div className="ml20 w100Per">
                  {getListWithQuantity()?.map((li) => {
                    return (
                      <div key={li?.batchId} className="mt10 ph5">
                        <div className="flex-row-ali-cen">
                          <div className="w25Per">
                            <Custom3dotString
                              str={li?.tradeName}
                              className="font-medium fs12 black16"
                            />
                          </div>
                          <div className="w35Per">
                            <div className="flex-row-ali-cen">
                              <div
                                className="flex-center cursor minus-icon"
                                onClick={() => removeItem(li)}
                              >
                                <RemoveIcon sx={remIcon} />
                              </div>
                              <div className="ph5">
                                <CustomTextField
                                  label=""
                                  name="quantity"
                                  fullWidth
                                  handleChange={(e) =>
                                    handleUpdateQuantity(li, e?.target?.value)
                                  }
                                  value={li?.quantity ?? 0}
                                  type="number"
                                />
                              </div>
                              {/* <Typography
                                className="black14 fs14 txt-semi-bold flex-center"
                                style={{ width: 25 }}
                              >
                                {li?.quantity}
                              </Typography> */}

                              <div
                                className="flex-center cursor plus-icon"
                                onClick={() => handleAddItem(li)}
                              >
                                <AddIcon sx={addIcon} />
                              </div>
                            </div>
                          </div>
                          <div className="w25Per flex-center">
                            <Typography className="font-medium fs12 black16">
                              Rs.{" "}
                              {Number(
                                getPriceByStockAndBatchId(
                                  li?.stockId,
                                  li?.batchId
                                )
                              )?.toFixed(2)}
                            </Typography>
                          </div>
                          <div className="w15Per">
                            {Number(createValues?.discountValue ?? 0) >
                            0 ? null : (
                              <div className="flex-column">
                                <div className="flex-center">
                                  <img
                                    src={require("../../../assets/images/png/discount.png")}
                                    className="img-wh15 cursor"
                                    onClick={() => handleDiscount(li)}
                                  />
                                </div>
                                <div className="flex-center mt5">
                                  <Typography className="font-medium yellow1 fs7">
                                    {`${
                                      li?.type && li?.value ? "Edit" : "Add"
                                    } Discout`}
                                  </Typography>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="box-hor-split mt10" />
                      </div>
                    );
                  })}
                </div>
                {!searchEnabled && createValues?.userId !== null ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row-between-align-center  w100Per mt15">
                      <div className="flex-end mb5 mtMin25">
                        <CurrencyExchange
                          sx={{
                            color: AppColors.appPrimary,
                            width: 20,
                            height: 20,
                          }}
                        />
                        <Typography
                          className="blue-color cursor txt-semi-bold fs14 underline"
                          onClick={handleCollectAdvance}
                        >
                          Collect/Refund
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null}
                <div className="flex1-end mt10">
                  <div>
                    <CustomButton
                      text={`${
                        Number(createValues?.discountValue) > 0
                          ? "Edit"
                          : "Apply"
                      } Discount`}
                      onClick={handleApplyDiscount}
                      smallBtn
                    />
                  </div>
                </div>
                <div className="flex-row-between-align-center pl20 w100Per mt15">
                  <Typography className="txt-semi-bold fs14 gray17">
                    Discount
                  </Typography>
                  <Typography className="txt-semi-bold fs14 gray17 pr20">
                    {Number(getDiscountAndTotal()?.discount) > 0
                      ? `Rs. ${Number(getDiscountAndTotal()?.discount).toFixed(
                          2
                        )}`
                      : "-"}
                  </Typography>
                </div>
                <div className="flex-row-between-align-center pl20 w100Per mt15">
                  <Typography className="txt-semi-bold fs14 gray17">
                    Tax
                  </Typography>
                  <Typography className="txt-semi-bold fs14 gray17 pr20">
                    {(createValues?.billAs === "Pharmacy"
                      ? clinicDet?.pharmacyTaxId
                      : clinicDet?.petShopTaxId
                    )?.length > 0
                      ? Number(getDiscountAndTotal()?.tax) > 0
                        ? `Rs. ${Number(getDiscountAndTotal()?.tax).toFixed(2)}`
                        : "-"
                      : "-"}
                  </Typography>
                </div>
                <div className="flex-row-between-align-center pl20 w100Per mt15">
                  <Typography className="txt-semi-bold fs14 blue-color">
                    Total
                  </Typography>
                  <Typography className="txt-semi-bold fs14 blue-color pr20">
                    {Number(getDiscountAndTotal()?.total) > 0
                      ? `Rs. ${Number(getDiscountAndTotal()?.total)?.toFixed(
                          2
                        )}`
                      : "-"}
                  </Typography>
                </div>
                {errors?.addedList && addedList?.length === 0 ? (
                  <FormHelperText error className="ml20">
                    Please Select at least 1 record
                  </FormHelperText>
                ) : null}
                <div className="w100Per">
                  <div className="flex1-end mt20">
                    <img
                      src={require("../../../assets/images/png/print.png")}
                      alt=""
                      className="imghw30 cursor"
                      onClick={() => {
                        setPrntPrevVsble(true);
                      }}
                    />
                    <div className="ml15">
                      <div>
                        <CustomButton
                          text="Save as Draft"
                          onClick={() => handleSubmit("draft")}
                          smallBtn
                          textBtn
                        />
                      </div>
                    </div>
                    <div className="ml15">
                      <div>
                        <CustomButton
                          text="Submit"
                          onClick={() => handleSubmit("finalize")}
                          smallBtn
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            ) : null}
          </div>
        </div>
      ) : null}

      <CustomModal
        open={disModVsble}
        onClose={onCloseDisMod}
        header={`${selectedBatchId ? "Edit" : "Apply"} Discount`}
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={0.5} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 selectypetext ">
              Discount Type
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomCheckbox
              radio
              onChange={(e) => onChangeDiscount("type", e?.target?.value)}
              radios={radioDiscountTypes}
              defaultValue={discountValues?.type ?? "percentage"}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextField
              label={`Discount  ${
                discountValues?.type === "price" ? "Price" : "Percentage"
              }`}
              name="value"
              fullWidth
              handleChange={(e) => onChangeDiscount("value", e?.target?.value)}
              value={discountValues?.value}
              labelTop
            />
          </Grid>

          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Add" onClick={handleAddDiscount} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={ttlDisModVsble}
        onClose={onCloseTtlDisMod}
        header={`${
          Number(createValues?.discountValue ?? 0) > 0 ? "Edit" : "Apply"
        } Discount`}
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={0.5} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 selectypetext ">
              Discount Type
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomCheckbox
              radio
              onChange={(e) => onChangeDiscount("type", e?.target?.value)}
              radios={radioDiscountTypes}
              defaultValue={discountValues?.type ?? "percentage"}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {discountValues?.type === "code" ? (
              <CustomSelect
                list={getDiscountCodes()}
                name="discountCode"
                value={discountValues?.discountCode}
                handleChange={(e, value) =>
                  onChangeDiscount("discountCode", value)
                }
                search
                error={errors?.discountCode}
                helperText={
                  errors?.discountCode ? "This field is required" : ""
                }
              />
            ) : (
              <CustomTextField
                label={`Discount  ${
                  discountValues?.type === "price" ? "Price" : "Percentage"
                }`}
                name="value"
                fullWidth
                handleChange={(e) =>
                  onChangeDiscount("value", e?.target?.value)
                }
                value={discountValues?.value}
                labelTop
                error={errors?.value}
                helperText={
                  errors?.value
                    ? discountValues?.value?.length > 0
                      ? "Value must be positive"
                      : "This field is required"
                    : ""
                }
              />
            )}

            {Number(createValues?.discountValue ?? 0) > 0 ? (
              <div
                className="flex-row-ali-cen mt10 cursor"
                onClick={onRemoveTtlDiscount}
              >
                <Typography className="font-medium fs14 red-color mr5">
                  Remove Discount
                </Typography>
                <CloseIcon
                  sx={{
                    color: AppColors.red,
                    width: 15,
                    height: 15,
                    stroke: AppColors.red,
                    strokeWidth: 2,
                  }}
                />
              </div>
            ) : null}
          </Grid>

          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Add"
                onClick={handleAddTtlDiscount}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={prntPrevVsble}
        onClose={handleClosePrintModal}
        header=""
        modal
        modalWidth={70}
      >
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <div ref={contentToPrint} className="bg">
            <div className="mt30">
              <div className="flex-row-ali-cen mv20">
                <div className="w30Per">
                  <div className="pl20">
                    <div>
                      {clinicDet?.image ? (
                        <img
                          src={clinicDet?.image}
                          className="img-h75"
                          alt=""
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {clinicDet?.name?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                    {/* <Typography className="flex-center fs18 txt-semi-bold mt10 blue-color">
                      {clinicDet?.name ?? profile?.name ?? ""}
                    </Typography> */}
                  </div>
                </div>
                <div className="w40Per flex-center">
                  <div className="font-bold fs18 blue-color">TAX INVOICE</div>
                </div>
                <div className="w30Per flex1-end">
                  <div className="flex-column">
                    <div className="font-bold fs12 blue-color">
                      Business Name:
                    </div>
                    <div className="font-medium blue-color fs12">
                      {clinicDet?.name ?? profile?.name ?? ""}
                    </div>
                    <div className="font-bold fs12 blue-color">
                      Business Address:
                    </div>
                    <div className="header-right-text2">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          {createValues?.billAs === "Pharmacy"
                            ? "PHARMACY"
                            : "PET SHOP"}{" "}
                          TAX ID:
                        </div>
                        <div className="header-right-text2 ml3">
                          {createValues?.billAs === "Pharmacy"
                            ? clinicDet?.pharmacyTaxId ?? ""
                            : clinicDet?.petShopTaxId ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="line" />
              <div className="flex1-end mt10 ph30">
                <div className="flex-column">
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Payment Status
                    </Typography>
                    {/* <Typography
                      className={`ml10 fs16 font-bold capitalize ${
                        selectedBill?.status === "paid"
                          ? "green2"
                          : selectedBill?.status === "unpaid"
                          ? "red2"
                          : "orange-color"
                      }`}
                    >
                      {selectedBill?.status}
                    </Typography> */}
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Total
                    </Typography>
                    <Typography className="black fs16 font-bold ml10">
                      {Number(getDiscountAndTotal()?.total) > 0
                        ? `Rs. ${Number(getDiscountAndTotal()?.total)?.toFixed(
                            2
                          )}`
                        : "-"}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Amount Paid
                    </Typography>
                    <Typography className="green-color fs16 font-bold ml10">
                      Rs{" "}
                      {selectedPayment?.amtPaid
                        ? Number(selectedPayment?.amtPaid) > 0
                          ? Number(selectedPayment?.amtPaid)?.toFixed(2)
                          : Number(selectedPayment?.amtPaid)
                        : "0"}
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="lower-container">
                <div className="box-container">
                  <div className="row-container">
                    <div>
                      <div className="colum-header">Pet Name</div>
                      <div className="colum-data">
                        {/* {selectedBill?.petName} */}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Parent Name</div>
                      <div className="colum-data capitalize">
                        {createValues?.userName}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Number</div>
                      <div className="colum-data">
                        {selectedPayment?.invoiceNumbers ?? ""}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Date</div>
                      <div className="colum-data">
                        {moment(new Date()).format("DD MMM YYYY")}
                      </div>
                    </div>
                  </div>

                  <div className="thin-line"></div>

                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>SERVICE / ITEM NAME</th>
                        <th>QTY</th>
                        <th>UNIT PRICE</th>
                        <th>DISCOUNT (Rs)</th>
                        <th>TAX</th>
                        <th>TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {addedList
                        ?.filter((li) => li?.quantity > 0)
                        ?.map((li) => {
                          const btchDet = getBatchDetailsByStockAndBatchId(
                            li?.stockId,
                            li?.batchId
                          );

                          const taxPercent =
                            (createValues?.billAs === "Pharmacy"
                              ? clinicDet?.pharmacyTaxId
                              : clinicDet?.petShopTaxId
                            )?.length > 0
                              ? Number(btchDet?.cgst ?? 0) +
                                Number(btchDet?.sgst ?? 0)
                              : 0;
                          const reqPercent = 100 + Number(taxPercent);
                          const unitPrice =
                            Number(btchDet?.unitSellingPrice) /
                            (reqPercent / 100);
                          const taxValue =
                            Number(btchDet?.unitSellingPrice) -
                            Number(unitPrice);

                          let price = 0,
                            total = 0,
                            discount = 0,
                            tax = taxValue;

                          if (li?.type === "price" && li?.value) {
                            const taxableValue =
                              Number(unitPrice) - Number(li?.value ?? 0);
                            const prdTaxValue =
                              Number(li?.quantity) *
                              ((taxPercent / 100) * Number(taxableValue));
                            tax = prdTaxValue;
                            discount = Number(li?.value ?? 0);
                            price = Number(unitPrice);
                            total =
                              Number(li?.quantity) * Number(taxableValue) +
                              Number(prdTaxValue);
                          }
                          if (li?.type === "percentage" && li?.value) {
                            const perPrice =
                              Number(
                                Number(Number(unitPrice) / 100) *
                                  Number(li?.value ?? 0)
                              ) ?? 0;
                            const taxableValue =
                              Number(unitPrice) - Number(perPrice ?? 0);
                            const prdTaxValue =
                              Number(li?.quantity) *
                              ((taxPercent / 100) * Number(taxableValue));
                            tax = prdTaxValue;
                            discount = perPrice;
                            price = Number(unitPrice);
                            total =
                              Number(li?.quantity) * Number(taxableValue) +
                              Number(prdTaxValue);
                          }
                          if (!li?.type && !li?.value) {
                            price = unitPrice;
                            total = Number(
                              Number(btchDet?.unitSellingPrice) *
                                Number(li?.quantity)
                            );
                            tax = Number(li?.quantity) * Number(taxValue);
                          }
                          let batchDet = null;
                          if (li?.batchId) {
                            batchDet = stocks?.data
                              ?.find((stc) => stc?.stockId === li?.stockId)
                              ?.stockBatch?.find(
                                (bat) => bat?.batchId === li?.batchId
                              );
                          }
                          return (
                            <tr>
                              <td>
                                <div className="flex-column">
                                  {li?.tradeName}
                                  {/* {batchDet ? (
                                    <div className="flex-row-ali-cen mt3">
                                      <Typography className="txt-regular fs10 gray-color">
                                        Mfg. Date:{" "}
                                        {moment(batchDet?.mfgDate).format(
                                          "DD MMM YYYY"
                                        )}
                                        {", "}
                                        Exp. Date:{" "}
                                        {moment(batchDet?.expiryDate).format(
                                          "DD MMM YYYY"
                                        )}
                                        {batchDet?.batchNo?.length > 0
                                          ? `, Batch No.: ${batchDet?.batchNo}`
                                          : ""}
                                      </Typography>
                                    </div>
                                  ) : null} */}
                                </div>
                              </td>
                              <td>{li?.quantity}</td>
                              <td>
                                Rs{" "}
                                {Number(btchDet?.unitSellingPrice)?.toFixed(2)}
                              </td>
                              <td>
                                {Number(discount) > 0
                                  ? `Rs ${Number(discount)?.toFixed(2)}`
                                  : "-"}
                              </td>
                              <td>
                                {Number(tax) > 0
                                  ? Number(tax)?.toFixed(2)
                                  : "-"}
                              </td>
                              <td>Rs {Number(total)?.toFixed(2)}</td>
                            </tr>
                          );
                        })}
                      <tr>
                        <td colSpan="6">
                          <hr className="thin-line2" />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="12">
                          <div className="flex-row-between">
                            <div className="w65Per ali-itm-flx-end">
                              <div className="flex-column w100Per">
                                <div className="flex-row-ali-cen mb5">
                                  <div className="txt-semi-bold fs12 black">
                                    Person In Charge:
                                  </div>
                                  <Typography className="font-bold fs12 gray4 ml10">
                                    {clinicDet?.name}
                                  </Typography>
                                </div>
                                <div className="flex-row-ali-cen mb5">
                                  <div className="txt-semi-bold fs12 black">
                                    Disclaimer:
                                  </div>
                                  <Typography className="fs12 txt-regular gray-color ml10">
                                    {clinicDet?.disclaimer}
                                  </Typography>
                                </div>
                              </div>
                            </div>
                            <div className="w35Per flex-end pr10">
                              <div className="flex-column w100Per">
                                <div className="flex-row-ali-cen mb5">
                                  <div className="w70Per">
                                    <div className="txtstyle">Discount</div>
                                  </div>
                                  <div className="w30Per flex-end">
                                    <div className="txtstyle">
                                      {Number(getDiscountAndTotal()?.discount) >
                                      0
                                        ? `Rs. ${Number(
                                            getDiscountAndTotal()?.discount
                                          ).toFixed(2)}`
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">Subtotal</div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      Rs{" "}
                                      {Number(
                                        Number(
                                          getDiscountAndTotal()?.total ?? 0
                                        ) -
                                          ((createValues?.billAs === "Pharmacy"
                                            ? clinicDet?.pharmacyTaxId
                                            : clinicDet?.petShopTaxId
                                          )?.length > 0
                                            ? Number(
                                                getDiscountAndTotal()?.tax ?? 0
                                              )
                                            : 0) +
                                          Number(
                                            getDiscountAndTotal()?.discount
                                          )
                                      )?.toFixed(2)}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">Tax</div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      Rs{" "}
                                      {(createValues?.billAs === "Pharmacy"
                                        ? clinicDet?.pharmacyTaxId
                                        : clinicDet?.petShopTaxId
                                      )?.length > 0
                                        ? Number(
                                            getDiscountAndTotal()?.tax
                                          ).toFixed(2)
                                        : Number(0)?.toFixed(2)}
                                    </div>
                                  </div>
                                </div>
                                <div className="balancecontainer ph5 mt10">
                                  <div className="flex-row-ali-cen w100Per">
                                    <div className="w60Per">
                                      <div className="txt-semi-bold fs14 blue-color">
                                        Total
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txt-semi-bold fs14 blue-color">
                                        {Number(getDiscountAndTotal()?.total) >
                                        0
                                          ? `Rs. ${Number(
                                              getDiscountAndTotal()?.total
                                            )?.toFixed(2)}`
                                          : "-"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <div className="mb20" />
                    </tbody>
                  </table>
                  <div className="flex-row mv20 ph10">
                    <img
                      src={require("../../../assets/images/jpg/WoofQrCode.jpeg")}
                      alt=""
                      className="img-h50"
                    />
                    <div className="blu-back wh50 flex-center">
                      <img
                        src={require("../../../assets/images/png/VetInstantLogo.png")}
                        alt=""
                        className="img-h40"
                      />
                    </div>
                    <div className="flex-center">
                      <div className="font-bold fs14 ml20">
                        Scan to download our app
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="back-white"
          >
            <div className="flex-end">
              <div className="mr20 mv20">
                <CustomButton
                  text="Download"
                  onClick={() =>
                    handlePrint(null, () => contentToPrint.current)
                  }
                  smallBtn
                />
              </div>
            </div>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={usrModVsble}
        onClose={usrModClose}
        header="Add new Customer"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  label="Parent Name"
                  name="userName"
                  fullWidth
                  handleChange={(e) => handleValueChange(e, "userName")}
                  value={usrValues?.userName}
                  error={!!usrErrs.userName}
                  helperText={usrErrs.userName}
                  required={true}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  label="Contact Number"
                  name="userMobile"
                  fullWidth
                  handleChange={(e) => handleValueChange(e, "userMobile")}
                  value={usrValues?.userMobile}
                  error={!!usrErrs.userMobile}
                  helperText={usrErrs.userMobile}
                  required={true}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  label="Email"
                  name="email"
                  fullWidth
                  handleChange={(e) => handleValueChange(e, "email")}
                  value={usrValues?.email}
                  error={!!usrErrs.email}
                  helperText={usrErrs.email}
                  required={true}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div>
                  <CustomButton text="Create" onClick={createUser} smallBtn />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>
      <CommonAdvancePayModalComponent
        open={advancePayVsble}
        onClose={handleClosePayMod}
        userDetails={usrValues}
      />

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {dropFields?.includes(li) ? (
                          <CustomSelect
                            list={getLocationsBySource(searchValues?.source)}
                            value={filterValues?.values?.[li] ?? []}
                            name={li}
                            handleChange={onFilterValuesChange}
                            label={li}
                            multiSelectSearchCheck
                          />
                        ) : li === "Qty Range" ||
                          li === "Subunit Qty Range" ||
                          li === "Unit Selling Price Range" ? (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder={getMinLable(li)}
                                fullWidth
                                name={getMinLable(li)}
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.[getMinLable(li)] ?? ""
                                }
                                label={getMinLable(li)}
                                type="number"
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder={getMaxLable(li)}
                                fullWidth
                                name={getMaxLable(li)}
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.[getMaxLable(li)] ?? ""
                                }
                                label={getMaxLable(li)}
                                type="number"
                              />
                            </div>
                          </div>
                        ) : li === "Mfg and Expiry Date" ? (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="Mfg Date"
                                fullWidth
                                name="Mfg Date"
                                handleChange={onFilterValuesChange}
                                value={filterValues?.values?.["Mfg Date"] ?? ""}
                                label="Mfg Date"
                                mobileDate
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="Expiry Date"
                                fullWidth
                                name="Expiry Date"
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.["Expiry Date"] ?? ""
                                }
                                label="Expiry Date"
                                mobileDate
                              />
                            </div>
                          </div>
                        ) : (
                          <CustomTextField
                            placeholder={li}
                            fullWidth
                            name={li}
                            handleChange={onFilterValuesChange}
                            value={filterValues?.values?.[li] ?? ""}
                            label={li}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default PointOfSales;
